/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MonitEntityHoneypotsOrderBy } from './MonitEntityHoneypotsOrderBy';
import {
    MonitEntityHoneypotsOrderByFromJSON,
    MonitEntityHoneypotsOrderByFromJSONTyped,
    MonitEntityHoneypotsOrderByToJSON,
} from './MonitEntityHoneypotsOrderBy';
import type { Tags } from './Tags';
import {
    TagsFromJSON,
    TagsFromJSONTyped,
    TagsToJSON,
} from './Tags';

/**
 * 
 * @export
 * @interface MonitGetEntityHoneypotsQueries
 */
export interface MonitGetEntityHoneypotsQueries {
    /**
     * 
     * @type {number}
     * @memberof MonitGetEntityHoneypotsQueries
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitGetEntityHoneypotsQueries
     */
    page_size?: number;
    /**
     * 
     * @type {string}
     * @memberof MonitGetEntityHoneypotsQueries
     */
    process_id?: string;
    /**
     * 
     * @type {Tags}
     * @memberof MonitGetEntityHoneypotsQueries
     */
    tags?: Tags;
    /**
     * 
     * @type {string}
     * @memberof MonitGetEntityHoneypotsQueries
     */
    source_asset?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitGetEntityHoneypotsQueries
     */
    search?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitGetEntityHoneypotsQueries
     */
    asset?: string;
    /**
     * 
     * @type {MonitEntityHoneypotsOrderBy}
     * @memberof MonitGetEntityHoneypotsQueries
     */
    order_by?: MonitEntityHoneypotsOrderBy;
    /**
     * 
     * @type {boolean}
     * @memberof MonitGetEntityHoneypotsQueries
     */
    desc?: boolean;
}

/**
 * Check if a given object implements the MonitGetEntityHoneypotsQueries interface.
 */
export function instanceOfMonitGetEntityHoneypotsQueries(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitGetEntityHoneypotsQueriesFromJSON(json: any): MonitGetEntityHoneypotsQueries {
    return MonitGetEntityHoneypotsQueriesFromJSONTyped(json, false);
}

export function MonitGetEntityHoneypotsQueriesFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitGetEntityHoneypotsQueries {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'process_id': !exists(json, 'process_id') ? undefined : json['process_id'],
        'tags': !exists(json, 'tags') ? undefined : TagsFromJSON(json['tags']),
        'source_asset': !exists(json, 'source_asset') ? undefined : json['source_asset'],
        'search': !exists(json, 'search') ? undefined : json['search'],
        'asset': !exists(json, 'asset') ? undefined : json['asset'],
        'order_by': !exists(json, 'order_by') ? undefined : MonitEntityHoneypotsOrderByFromJSON(json['order_by']),
        'desc': !exists(json, 'desc') ? undefined : json['desc'],
    };
}

export function MonitGetEntityHoneypotsQueriesToJSON(value?: MonitGetEntityHoneypotsQueries | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'process_id': value.process_id,
        'tags': TagsToJSON(value.tags),
        'source_asset': value.source_asset,
        'search': value.search,
        'asset': value.asset,
        'order_by': MonitEntityHoneypotsOrderByToJSON(value.order_by),
        'desc': value.desc,
    };
}

